export default "__VITE_ASSET__BoRTrQ_W__"